import { createReducer, on } from "@ngrx/store";
import { ImportExternalResultsState, initialImportExternalResultsState } from "./import-external-results.state";
import { 
  AuthorizeImportExternalResultsSSE, 
  AuthorizeImportExternalResultsSSEError, 
  AuthorizeImportExternalResultsSSESuccess, 
  CancelExternalResultsImport, 
  CancelExternalResultsImportError, 
  CancelExternalResultsImportSuccess, 
  ClearExternalResultsImportSession, 
  ClearExternalResultsImportSessionResult, 
  DownloadExternalResultsImportErrorList, 
  DownloadExternalResultsImportErrorListError, 
  DownloadExternalResultsImportErrorListSuccess, 
  GetExternalResultsImportStatusError, 
  GetExternalResultsImportStatusSuccess, 
  HasImportedExternalResults, 
  HasImportedExternalResultsError, 
  HasImportedExternalResultsSuccess, 
  ResetExternalResultsImportState, 
  UploadExternalResultsCSV, 
  UploadExternalResultsCSVError, 
  UploadExternalResultsCSVSuccess } from "./import-external-results.action";

export const ImportExternalResultsReducers = createReducer(
  initialImportExternalResultsState,
  on(UploadExternalResultsCSV, (state): ImportExternalResultsState => {
    return {
      ...state,
      uploadLoader: true,
      uploadResult: null,
      uploadError: null,
    }
  }),
  on(UploadExternalResultsCSVSuccess, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      uploadLoader: false,
      uploadResult: action.result,
    };
  }),
  on(UploadExternalResultsCSVError, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      uploadLoader: false,
      uploadError: action.error,
    };
  }),
  on(GetExternalResultsImportStatusSuccess, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      statusLoader: false,
      statusResult: action.result,
    };
  }),
  on(GetExternalResultsImportStatusError, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      statusLoader: false,
      statusError: action.error,
    };
  }),
  on(AuthorizeImportExternalResultsSSE, (state): ImportExternalResultsState => {
    return {
      ...state,
      authSSELoader: true,
      authSSEResult: false,
      authSSEError: null,
    };
  }),
  on(AuthorizeImportExternalResultsSSESuccess, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      authSSELoader: false,
      authSSEResult: action.result,
    };
  }),
  on(AuthorizeImportExternalResultsSSEError, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      authSSELoader: false,
      authSSEError: action.error,
    };
  }),
  on(HasImportedExternalResults, (state): ImportExternalResultsState => {
    return {
      ...state,
      hasImportLoader: true,
      hasImportResult: 0,
      hasImportError: null,
    };
  }),
  on(HasImportedExternalResultsSuccess, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      hasImportLoader: false,
      hasImportResult: action.result,
    };
  }),
  on(HasImportedExternalResultsError, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      hasImportLoader: false,
      hasImportError: action.error,
    };
  }),
  on(DownloadExternalResultsImportErrorList, (state): ImportExternalResultsState => {
    return {
      ...state,
      errorListFile: null,
      errorListLoader: true,
      errorListError: null,
    };
  }),
  on(DownloadExternalResultsImportErrorListSuccess, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      errorListFile: action.result,
      errorListLoader: false,
    };
  }),
  on(DownloadExternalResultsImportErrorListError, (state, action): ImportExternalResultsState => {
    return {
      ...state,
      errorListLoader: false,
      errorListError: action.error,
    };
  }),
  on(CancelExternalResultsImport, (state): ImportExternalResultsState => {
    return {
      ...state,
      cancelImportLoader: true,
      cancelImportResult: null,
    };
  }),
  on(CancelExternalResultsImportSuccess, (state): ImportExternalResultsState => {
    return {
      ...state,
      cancelImportLoader: false,
      cancelImportResult: true,
    };
  }),
  on(CancelExternalResultsImportError, (state): ImportExternalResultsState => {
    return {
      ...state,
      cancelImportLoader: false,
      cancelImportResult: false,
    };
  }),
  on(ClearExternalResultsImportSession, (state): ImportExternalResultsState => {
    return {
      ...state,
      clearSessionLoader: true,
    };
  }),
  on(ClearExternalResultsImportSessionResult, (state): ImportExternalResultsState => {
    return {
      ...state,
      clearSessionLoader: true,
    };
  }),
  on(ResetExternalResultsImportState, (): ImportExternalResultsState => {
    return initialImportExternalResultsState;
  }),
);